import { t } from 'i18next'

export const CORE_PACKAGE = 'Core'

export const BRAND_NAME = t('core:breadcrumbBrand')

export const URL_PREFIX = window.location.host.split('.')[0]

export const formatBreadcrumbLabel = (label, preserveHyphens = false) => {
  if (!label) return ''
  if (preserveHyphens) return label
  return label?.replace(/-/g, ' ')
}
